// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wusn","top":"styles_top__18NMN","left":"styles_left__kRZY3","description":"styles_description__mmbdm"};